import React from 'react';
import { RotateCcw } from 'lucide-react';

const ErrorDisplay = ({ 
  error, 
  onRetry, 
  className = '', 
  isDarkMode = false 
}) => {
  if (!error) return null;

  const handleRetry = () => {
    if (onRetry) {
      onRetry();
    }
  };

  return (
    <div 
      className={`
        flex items-center gap-2 p-3 rounded-lg border cursor-pointer
        transition-colors duration-200 hover:opacity-80
        ${isDarkMode 
          ? 'bg-red-900/20 border-red-800/30 text-red-300 hover:bg-red-900/30' 
          : 'bg-red-50 border-red-200 text-red-700 hover:bg-red-100'
        }
        ${className}
      `}
      onClick={handleRetry}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleRetry();
        }
      }}
    >
      <RotateCcw 
        size={16} 
        className={`
          flex-shrink-0 transition-transform duration-200 hover:rotate-180
          ${isDarkMode ? 'text-red-400' : 'text-red-600'}
        `} 
      />
      <span className="text-sm font-medium flex-1">
        {typeof error === 'string' ? error : error?.message || 'Something went wrong. Click to retry.'}
      </span>
    </div>
  );
};

export default ErrorDisplay;